import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-[500px] mx-auto py-6" }
const _hoisted_2 = { class: "col-span-2" }
const _hoisted_3 = { class: "w-full flex items-center justify-end space-x-3" }

import { ref } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import FormSection from "./FormSection.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import { useRouter } from "vue-router";
import PrimaryDiagnosisService from "@/classes/Settings/PrimaryDiagnosisService";
import { errorResponse } from "@/helpers/errorMessage";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePage',
  setup(__props) {

const router = useRouter();

const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const successMessage = ref<string>("Data has been successfully saved!");
const form = ref<{ name: string }>({
	name: "",
});
const errors = ref<any>();

const save = (): void => {
	PrimaryDiagnosisService.store(form.value)
		.then((response: any) => {
			showConfirmation.value = true;
			successMessage.value = response.data.message;
		})
		.catch((error: any) => (errors.value = errorResponse(error.response?.data?.errors)));
};

const redirectSuccess = (): void => {
	showSuccess.value = false;
	router.replace("/settings/primary-diagnosis/index");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: true,
    backLink: "/settings/primary-diagnosis/index"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormSection, {
          form: form.value,
          errors: errors.value
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace('/settings/primary-diagnosis/index')))
                }, [
                  _createVNode(ButtonComponent, { btnWidth: "quinary" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cancel")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(ButtonComponent, {
                  btnWidth: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (save()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Save Changes")
                  ]),
                  _: 1
                })
              ]),
              _createVNode(ConfirmationModal, {
                typeTwo: true,
                show: showConfirmation.value,
                onCancel: _cache[2] || (_cache[2] = ($event: any) => (showConfirmation.value = false)),
                onConfirm: _cache[3] || (_cache[3] = ($event: any) => {
							showSuccess.value = true;
							showConfirmation.value = false;
						}),
                "cancel-text": "Cancel",
                "action-text": "Confirm",
                title: "Save Record",
                content: "Are you sure you wish to save this record?"
              }, null, 8, ["show"]),
              _createVNode(SuccessModal, {
                show: showSuccess.value,
                onConfirm: _cache[4] || (_cache[4] = ($event: any) => (redirectSuccess())),
                "action-text": "Close",
                title: "Record Saved!",
                content: successMessage.value
              }, null, 8, ["show", "content"])
            ])
          ]),
          _: 1
        }, 8, ["form", "errors"])
      ])
    ]),
    _: 1
  }))
}
}

})